import Model, { valueWithArray } from 'ducker-model';
import tool from '@/utils/tool';

const property = {
  newsList: valueWithArray(Object),
};

const replacedKeyFromPropertyName = {
  newsList: {
    property: 'news',
    computed: (list) => {
      const handleSubTitle = (type, date) => {
        const dateText = tool.formatDateTime(date, false);
        return `${type} ${dateText}`;
      };
      if (list?.length) {
        const temp = [];
        list.forEach((item) => {
          temp.push({
            title: item.title,
            subTitle: handleSubTitle(item.mediaName, item.showTime),
            newsCode: item.code,
          });
        });
        return temp;
      }
      return [];
    },
  },
};

export default new Model(property, replacedKeyFromPropertyName);
